import Icon from '../Icon';

const AlwaysReadyIcon = (props) => {
    return (
        <Icon width='201' height='200' viewBox='0 0 201 200' fill='none' {...props}>
            <path
                d='M38.1055 92.1875H100.605C108.418 91.6667 124.043 85.9375 124.043 67.1875C124.043 48.4375 108.418 40.625 99.043 40.625C89.668 40.625 72.4805 45.9375 72.4805 67.1875'
                stroke='#00D1D2'
                strokeWidth='9.375'
                strokeLinecap='round'
            />
            <path d='M94.3555 145.312H102.168' stroke='#FFFDFB' strokeWidth='9.375' strokeLinecap='round' />
            <path d='M56.8555 110.938H64.668' stroke='#FFFDFB' strokeWidth='9.375' strokeLinecap='round' />
            <path d='M134.98 92.1875H142.793' stroke='#FFFDFB' strokeWidth='9.375' strokeLinecap='round' />
            <path d='M78.7305 110.938H159.98' stroke='#FFFDFB' strokeWidth='9.375' strokeLinecap='round' />
            <path
                d='M42.793 129.692C42.793 129.692 128.73 129.688 131.855 129.692C140.06 129.705 149.043 132.815 149.043 145.317C149.043 165.893 116.23 165.788 116.23 145.317'
                stroke='#00D1D2'
                strokeWidth='9.375'
                strokeLinecap='round'
            />
        </Icon>
    );
};

export default AlwaysReadyIcon;
